<template>
  <div>
    <TicketSearch
      :delete-case="deleteCase"
      :download-document="downloadDocument"
      :get-case-documents="getCaseDocuments"
      :get-comment-history="getCommentHistory"
      :get-status="getUserCaseStatus"
      :get-user-cases="getUserCases"
      :save-additional-info="saveAdditionalInfo"
      :status-id="statusId"
      @on-open-case="onOpenCaseHandler"
    />
  </div>
</template>

<script>
import TicketSearch from '@/views/helpdesk/TicketSearch.vue';
import {
  getUserCases as _getUserCases,
  getUserCaseStatus as _getUserCaseStatus,
  deleteCase as _deleteCase,
  saveAdditionalInfo as _saveAdditionalInfo,
  getCommentHistory as _getCommentHistory,
  getCaseAttachments as _getCaseAttachments,
  downloadDocument as _downloadDocument,
} from '@/services/common/helpdesk.api.js';

export default {
  name: 'CaseListMain',
  components: { TicketSearch },
  computed: {
    statusId() {
      return this.$route.params.status;
    },
  },
  methods: {
    getUserCases(params, pageIndex, pageSize) {
      return _getUserCases(params, pageIndex, pageSize);
    },
    getUserCaseStatus() {
      return _getUserCaseStatus();
    },
    onOpenCaseHandler(item) {
      const { id } = item;

      this.$router.push({ name: 'DetailsTicket', params: { id } });
    },
    deleteCase(id) {
      return _deleteCase(id);
    },
    saveAdditionalInfo(formData) {
      return _saveAdditionalInfo(formData);
    },
    getCommentHistory(caseNumber) {
      return _getCommentHistory(caseNumber);
    },
    getCaseDocuments(caseNumber) {
      return _getCaseAttachments(caseNumber);
    },
    downloadDocument(document) {
      return _downloadDocument(document.id);
    },
  },
};
</script>
